export default "__VITE_ASSET__CXlWCYA0__"